import axios from 'axios'
import { Toast } from 'vant'

const http = axios.create({
  baseURL: '/api',
  timeout: 15000
})

// 统一拆包: 后端返回 { code, message, data }
http.interceptors.response.use(
  res => {
    const body = res.data
    if (body && body.code === 0) {
      return body.data
    }
    const msg = (body && body.message) || '请求失败'
    Toast.fail(msg)
    return Promise.reject(new Error(msg))
  },
  err => {
    Toast.fail('网络异常')
    return Promise.reject(err)
  }
)

export default {
  // 分类
  getCategories: () => http.get('/categories'),

  // 菜品
  getDishes: categoryId => http.get('/dishes', { params: { categoryId } }),
  createDish: form => http.post('/dishes', form),
  updateDish: (id, form) => http.put(`/dishes/${id}`, form),
  deleteDish: id => http.delete(`/dishes/${id}`),

  // 图片上传
  upload: file => {
    const data = new FormData()
    data.append('file', file)
    return http.post('/upload', data, { headers: { 'Content-Type': 'multipart/form-data' } })
  },

  // 今日菜单
  getDailyMenu: () => http.get('/daily-menu'),
  addDailyMenu: form => http.post('/daily-menu', form),
  toggleMenuDone: id => http.put(`/daily-menu/${id}/done`),
  deleteDailyMenu: id => http.delete(`/daily-menu/${id}`),
  clearDailyMenu: () => http.delete('/daily-menu/clear'),
  getDiary: () => http.get('/daily-menu/history'),

  // 采购清单
  getShopping: () => http.get('/shopping'),
  addShopping: form => http.post('/shopping', form),
  toggleShoppingCheck: id => http.put(`/shopping/${id}/check`),
  resetShopping: () => http.put('/shopping/reset'),
  clearShopping: () => http.delete('/shopping/clear'),

  // 周计划
  getWeekPlan: () => http.get('/week-plan'),
  addWeekPlan: form => http.post('/week-plan', form),
  deleteWeekPlan: id => http.delete(`/week-plan/${id}`),
  clearWeekPlan: () => http.delete('/week-plan/clear'),
  generateShopping: () => http.post('/week-plan/generate-shopping'),
  syncWeekPlan: () => http.post('/week-plan/sync')
}
